// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-choose-us-section {
    text-align: center;
    padding: 60px 20px;
    background-color: #f5f5f5;
  }
  
  .why-choose-us-section h2 {
    font-size: 28px;
    margin-bottom: 20px;
    color: #333;
  }
  
  .why-description {
    font-size: 16px;
    color: #555;
    margin: 0 auto 40px;
    max-width: 800px;
    line-height: 1.6;
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
    max-width: 1000px;
    margin: 0 auto;
  }
  
  .feature-card {
    background-color: #fff;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: transform 0.3s ease;
  }
  
  .feature-card:hover {
    transform: translateY(-5px);
  }
  
  .feature-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 20px;
  }
  
  .feature-card h3 {
    font-size: 20px;
    color: #222;
    margin-bottom: 15px;
  }
  
  .feature-card p {
    font-size: 14px;
    color: #666;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/WhyChooseUsSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb","sourcesContent":[".why-choose-us-section {\n    text-align: center;\n    padding: 60px 20px;\n    background-color: #f5f5f5;\n  }\n  \n  .why-choose-us-section h2 {\n    font-size: 28px;\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  .why-description {\n    font-size: 16px;\n    color: #555;\n    margin: 0 auto 40px;\n    max-width: 800px;\n    line-height: 1.6;\n  }\n  \n  .features-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 40px;\n    max-width: 1000px;\n    margin: 0 auto;\n  }\n  \n  .feature-card {\n    background-color: #fff;\n    padding: 30px;\n    border-radius: 12px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    transition: transform 0.3s ease;\n  }\n  \n  .feature-card:hover {\n    transform: translateY(-5px);\n  }\n  \n  .feature-icon {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 20px;\n  }\n  \n  .feature-card h3 {\n    font-size: 20px;\n    color: #222;\n    margin-bottom: 15px;\n  }\n  \n  .feature-card p {\n    font-size: 14px;\n    color: #666;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
